import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { Container, Card, Row, Col, } from "react-bootstrap";

import Header from "./Header";
import Companies from "../pages/CompaniesList";
import CompanyMap from "../../components/widgets/VectorMaps/CompanyMap";
import CompaniesByIndustry from "../../components/widgets/CompaniesByIndustry";
import CompaniesBySubIndustry from "../../components/widgets/CompaniesBySubIndustry";
import CompaniesByRegion from "../../components/widgets/CompaniesByRegion";
import CompaniesByCapability from "../../components/widgets/CompaniesByCapability";
import RevenueByIndustry from "../../components/widgets/RevenueByIndustry";
import FTEByIndustry from "../../components/widgets/FTEByIndustry";

const AdminDashboard = () => {


  return (
    // <React.Fragment>
    //   <Helmet title="ADMIN Dashboard" />
    //   <Container fluid className="p-0">
    //     <Header />
    //     <Card>
    //       <Card.Body>
    //         <Row>
    //           <Col>
    //             {/* <CompaniesByPostCode /> */}
    //           </Col>
    //           <Col>
    //             {/* <CompaniesByIndustry /> */}
    //           </Col>
    //         </Row>
    //         <Row>
    //           <CompanyMap />
    //         </Row>
    //         <Row>
    //           <Companies admin={true} />
    //         </Row>
    //       </Card.Body>
    //     </Card>
    //   </Container>
    // </React.Fragment>
    <React.Fragment>
      <Helmet title="Visualisations" />
      <Container fluid className="p-0">
        <Header />
        <Row>
          <Row>
            <Col md={6}>
              <Card>
                <Card.Body>
                  <div style={{ width: '100%', height: '100%' }}>
                    <CompaniesByIndustry />
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6}>
              <Card>
                <Card.Body>
                  <div style={{ width: '100%', height: '100%' }}>

                    <CompaniesBySubIndustry />
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Card>
                <Card.Body>
                  <div style={{ width: '100%', height: '100%' }}>
                    <CompaniesByRegion />
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6}>
              <Card>
                <Card.Body>
                  <div style={{ width: '100%', height: '100%' }}>
                    <CompaniesByCapability />
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6}>
              <Card>
                <Card.Body>
                  <div style={{ width: '100%', height: '100%' }}>
                    <RevenueByIndustry />
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6}>
              <Card>
                <Card.Body>
                  <div style={{ width: '100%', height: '100%' }}>
                    <FTEByIndustry />
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Card>
                <Card.Body>
                  <div style={{ width: '100%', height: '100%' }}>
                    <CompanyMap />
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Row>

      </Container>
    </React.Fragment>
  )
};

export default AdminDashboard;
